import * as ng from 'angular';

ng.module('e360')
   .directive('delayedChange', delayedChangeDirective);

/**
 * Evaluate the given expression when the user changes the input and
 * a debounce timeout has occurred. Default timeout is 1000 milliseconds.
 * Adjust the timeout with `delayed-change-timeout=X`.
 *
 * This directive is very similar to the following:
 * `<input ng-model="obj.foo" ng-change="fooChanged()" ng-model-options="{debounce: 1000}">`
 *
 * However when using `ng-change` with the state/country select directives
 * the `ng-change` was evaluated before the internal watch expressions
 * on ng-model where triggered. The effect was `ng-change` occurring
 * before `on-state-select`, and thus before the full state model could
 * be resolved.
 */
delayedChangeDirective.$inject = ['$timeout'];
export function delayedChangeDirective($timeout:ng.ITimeoutService) {
   return {
      restrict: 'A',
      require: 'ngModel',
      link: delayedChangeDirectiveLink
   };

   function delayedChangeDirectiveLink(scope:ng.IScope, e, attr:ng.IAttributes, ctrl:ng.INgModelController) {
      let evalDelay = 1000;
      if (attr.delayedChangeTimeout) {
         evalDelay = parseInt(attr.delayedChangeTimeout);
      }

      let timeoutPromise:ng.IPromise<void>;

      ctrl.$viewChangeListeners.push(() => {
         if (timeoutPromise) {
            $timeout.cancel(timeoutPromise);
         }

         timeoutPromise = $timeout(() => {
            scope.$eval(attr.delayedChange);
            timeoutPromise = null;
         }, evalDelay);
      });
   }
}
